<template>
    <div class="finance-page banking banking-page">
        <div class="finance-page__inner">
            <header class="finance-hero">
                <div class="finance-hero__icon" aria-hidden="true">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M3 10h18" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M7 15h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </div>
                <div>
                    <h1 class="finance-hero__title">{{ $t('banking.bank_info') }}</h1>
                    <p class="finance-hero__subtitle">
                        {{
                            $store.state.language === 'en'
                                ? 'This account receives withdrawals. Use your real name and number as registered with the bank or wallet.'
                                : 'ဤအကောင့်သို့ ငွေထုတ်ပေးမည်။ ဘဏ် သို့မဟုတ် ပိုက်ဆံအိတ်တွင် မှတ်ပုံတင်ထားသည့်အတိုင်း အမည်နှင့် နံပါတ်ထည့်ပါ။'
                        }}
                    </p>
                </div>
            </header>

            <div v-if="error" class="finance-alert finance-alert--error" role="alert">
                {{ error }}
            </div>

            <form class="finance-form" @submit.prevent>
                <section class="finance-card">
                    <label class="finance-label" for="bank-username">{{ $t('banking.bank_username') }}</label>
                    <p class="finance-hint">
                        {{
                            $store.state.language === 'en'
                                ? 'Must match your wallet or bank account name.'
                                : 'ပိုက်ဆံအိတ်/ဘဏ်အကောင့်အမည်နှင့် တူညီရမည်။'
                        }}
                    </p>
                    <input
                        id="bank-username"
                        type="text"
                        class="finance-input finance-input--left"
                        autocomplete="name"
                        v-model="account.name"
                        :placeholder="$store.state.language === 'en' ? 'Account holder name' : 'အကောင့်ကိုင်ဆောင်သူ အမည်'"
                    />
                    <p v-if="errors.name" class="finance-field-error">{{ errors.name }}</p>
                </section>

                <section class="finance-card">
                    <label class="finance-label" for="bank-number">{{ $t('banking.bank_number') }}</label>
                    <p class="finance-hint">
                        {{
                            $store.state.language === 'en'
                                ? 'Phone or account number without spaces.'
                                : 'နေရာလွတ် မထည့်ပါနှင့်။'
                        }}
                    </p>
                    <input
                        id="bank-number"
                        type="text"
                        inputmode="numeric"
                        class="finance-input"
                        autocomplete="off"
                        v-model="account.account_number"
                        :placeholder="$store.state.language === 'en' ? '09…' : 'နံပါတ်'"
                    />
                    <p v-if="errors.number" class="finance-field-error">{{ errors.number }}</p>
                </section>

                <section class="finance-card">
                    <h2 class="finance-card__label">{{ $t('banking.bank_type') }}</h2>
                    <AccountSelect
                        :data="account"
                        field="type"
                        :accounts="accounts"
                    />
                    <p v-if="errors.account" class="finance-field-error">{{ errors.account }}</p>
                </section>

                <button
                    type="button"
                    class="finance-btn-primary"
                    :disabled="isConfirm"
                    @click="updateBankInfo()"
                >
                    <Loading v-if="isConfirm" color="#0d0d0d" size="24" class="finance-btn-primary__spin"/>
                    <span v-else>{{ $t('banking.submit') }}</span>
                </button>

                <section class="finance-note-card">
                    <h3 class="finance-note-card__title">{{ $t('banking.note') }}</h3>
                    <p class="finance-note-card__body">{{ $t('banking.note_content') }}</p>
                </section>
            </form>
        </div>
    </div>
</template>
<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      selected_account: {
        account_id: null,
      },
      error: null,
      accounts: [
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ Mobile Banking',
          id: 'KBZ Mobile Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kbz.png',
        },
        {
          name: 'Wave pay',
          id: 'Wave pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
      ],
      account: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    async fetchBankInfo() {
      try {
        const res = await axios.get('/user_bank',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          },
        );
        this.account = res.data.data || {};
      } catch (err) {
        console.log(err);
      }
    },
    ...mapActions(['fetchUser']),
    async updateBankInfo() {
      this.errors = {};
      this.error = null;
      if (!this.account.type) {
        this.errors.account = this.$store.state.language === 'en'
          ? 'Please pick account type'
          : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
        return false;
      }
      if (!this.account.account_number) {
        this.errors.number = this.$store.state.language === 'en'
          ? 'Please enter account number'
          : 'အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
        return false;
      }
      if (!this.account.name) {
        this.errors.name = this.$store.state.language === 'en'
          ? 'Please enter bank username'
          : 'အကောင့်အမည် ထည့်သွင်းပေးပါ။';
        return false;
      }

      try {
        this.isConfirm = true;
        await axios.put('/user_bank', this.account, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        this.error = null;
        Toast.success('Success');
        this.isConfirm = false;
      } catch (error) {
        this.error = error.response && error.response.data ? error.response.data : error.message;
        this.isConfirm = false;
      }
      return true;
    },
  },
  async mounted() {
    await this.fetchBankInfo();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
  },
};
</script>
<style scoped>
.banking-page {
  --finance-accent: rgb(240, 97, 38);
  --finance-accent-soft: rgba(240, 97, 38, 0.22);
  --finance-surface: #141414;
  --finance-text: #e8e8e8;
  --finance-muted: #9a9a9a;
  --finance-radius: 14px;
}

.finance-page {
  min-height: 100vh;
  overflow-y: auto;
  padding: 1rem 1rem 6rem;
  background:
    radial-gradient(ellipse 75% 45% at 20% -15%, rgba(120, 160, 255, 0.1), transparent),
    radial-gradient(ellipse 60% 40% at 90% 10%, rgba(240, 97, 38, 0.12), transparent),
    linear-gradient(180deg, #0c0c0c 0%, #101010 45%, #0a0a0a 100%);
  -webkit-overflow-scrolling: touch;
}

.finance-page__inner {
  max-width: 520px;
  margin: 0 auto;
}

.finance-hero {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.finance-hero__icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--finance-surface);
  border: 1px solid var(--finance-accent-soft);
  color: var(--finance-accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.finance-hero__title {
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--finance-text);
  margin: 0 0 0.35rem;
  letter-spacing: -0.02em;
}

.finance-hero__subtitle {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: var(--finance-muted);
}

.finance-alert {
  border-radius: var(--finance-radius);
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.finance-alert--error {
  background: rgba(220, 53, 69, 0.12);
  border: 1px solid rgba(220, 53, 69, 0.35);
  color: #ffb4b4;
}

.finance-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.finance-card {
  background: var(--finance-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: var(--finance-radius);
  padding: 1.1rem 1.15rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
}

.finance-card__label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--finance-muted);
  margin: 0 0 0.65rem;
}

.finance-label {
  display: block;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--finance-text);
  margin-bottom: 0.25rem;
}

.finance-hint {
  margin: 0 0 0.6rem;
  font-size: 0.78rem;
  color: var(--finance-muted);
  line-height: 1.4;
}

.finance-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #0a0a0a;
  color: #fff;
  font-size: 1.05rem;
  text-align: center;
  box-shadow: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.finance-input--left {
  text-align: left;
}

.finance-input:focus {
  outline: none;
  border-color: var(--finance-accent-soft);
  box-shadow: 0 0 0 3px rgba(240, 97, 38, 0.15);
}

.finance-input::placeholder {
  color: #555;
}

.finance-field-error {
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  color: #ff8a8a;
}

.finance-btn-primary {
  margin-top: 0.25rem;
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(180deg, #ff8c42 0%, var(--finance-accent) 55%, #c94a18 100%);
  color: #0d0d0d;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.02em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(240, 97, 38, 0.35);
  transition: opacity 0.2s ease, transform 0.1s ease;
}

.finance-btn-primary:disabled {
  opacity: 0.75;
  cursor: wait;
}

.finance-btn-primary:active:not(:disabled) {
  transform: scale(0.99);
}

.finance-btn-primary__spin {
  padding: 0 !important;
}

.finance-note-card {
  margin-top: 0.25rem;
  padding: 1rem 1.1rem;
  border-radius: var(--finance-radius);
  background: rgba(0, 0, 0, 0.35);
  border: 1px dashed rgba(240, 97, 38, 0.28);
}

.finance-note-card__title {
  margin: 0 0 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--finance-muted);
}

.finance-note-card__body {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.5;
  color: var(--finance-muted);
}
</style>
<style>
/* vue-select inside banking layout */
.banking-page.banking .v-select .vs__dropdown-toggle {
  /* min-height: 48px;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: #0a0a0a !important;
  padding: 0.25rem 0.5rem; */
}

.banking-page.banking .v-select .vs__selected,
.banking-page.banking .v-select .vs__search {
  color: #fff !important;
}

.banking-page.banking .v-select .vs__dropdown-menu {
  background: #1a1a1a !important;
  border: 1px solid rgba(240, 97, 38, 0.25) !important;
  border-radius: 12px !important;
}
</style>
